import React from 'react'
export const getFaviconLinks = (orgDomainMaskFavicon?: string) => {
  if (orgDomainMaskFavicon) return <link rel="icon" href={orgDomainMaskFavicon} />

  return (
    <>
      <link rel="icon" href="/favicon.ico?v=3" sizes="any" />
    </>
  )
}
